import { memo } from "react";

export const PlayList = memo(() => {
    return <div>PlayList</div>;
});
